import React, { useState } from 'react';
import { Tab as TabMui, Tabs as TabsMui } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Block } from './content';
const Tab = props => /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
const Tabs = _ref => {
  let {
    children,
    defaultValue,
    onChange,
    variant = 'fullWidth'
  } = _ref;
  const [value, setValue] = useState(defaultValue);
  const [tabs] = useState(Array.isArray(children) ? children : [children]);
  if (!children) {
    return null;
  }
  const onTabChange = (_, newValue) => {
    setValue(newValue);
    onChange && onChange(newValue);
  };
  const currentTab = tabs.filter(x => x).find(tab => tab.props.id === value);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabsMui, {
    variant: variant,
    indicatorColor: "primary",
    value: value,
    onChange: onTabChange
  }, tabs.filter(x => x).map(tab => {
    const {
      id,
      title
    } = tab.props;
    return /*#__PURE__*/React.createElement(TabMui, {
      id: id,
      key: id,
      value: id,
      label: title
    });
  })), /*#__PURE__*/React.createElement(Block, {
    marginTop: 2
  }, currentTab.props.children));
};
Tab.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.any
};
Tabs.propTypes = {
  defaultValue: PropTypes.string,
  children: PropTypes.any
};
export { Tabs, Tab };